export const routePaths = {
  login: '/login',
  register: '/register',
  phone: '/start',
  dashboard: '/dashboard',
  terms: '/terms',
  privacy: '/privacy',
} as const;

export type RoutePath = (typeof routePaths)[keyof typeof routePaths];
